import { GenIcon } from '../helpers/IconBase.es.js';

const GarbageFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-u0oj6iqab", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M15.3659 5.52269H21.2534C21.6676 5.52269 22.0034 5.85848 22.0034 6.27269C22.0034 6.6869 21.6676 7.02269 21.2534 7.02269H2.75C2.33579 7.02269 2 6.6869 2 6.27269C2 5.85848 2.33579 5.52269 2.75 5.52269H8.63739V3.81817C8.63739 3.36631 9.01394 3 9.47845 3H14.5248C14.9893 3 15.3659 3.36631 15.3659 3.81817V5.52269ZM18.7302 9.54538L18.001 19.4796C17.9384 20.3361 17.2058 20.9998 16.3231 20.9998H7.68032C6.79764 20.9998 6.06507 20.3361 6.0024 19.4796L5.27319 9.54538H18.7302Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.3659 5.52269H21.2534C21.6676 5.52269 22.0034 5.85848 22.0034 6.27269C22.0034 6.6869 21.6676 7.02269 21.2534 7.02269H2.75C2.33579 7.02269 2 6.6869 2 6.27269C2 5.85848 2.33579 5.52269 2.75 5.52269H8.63739V3.81817C8.63739 3.36631 9.01394 3 9.47845 3H14.5248C14.9893 3 15.3659 3.36631 15.3659 3.81817V5.52269ZM18.7302 9.54538L18.001 19.4796C17.9384 20.3361 17.2058 20.9998 16.3231 20.9998H7.68032C6.79764 20.9998 6.06507 20.3361 6.0024 19.4796L5.27319 9.54538H18.7302Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.3659 5.52269H14.3659V6.52269H15.3659V5.52269ZM8.63739 5.52269V6.52269H9.63739V5.52269H8.63739ZM18.001 19.4796L17.0037 19.4064L17.0037 19.4067L18.001 19.4796ZM18.7302 9.54538L19.7275 9.61859L19.8063 8.54538H18.7302V9.54538ZM6.0024 19.4796L6.99973 19.4067L6.99971 19.4064L6.0024 19.4796ZM5.27319 9.54538V8.54538H4.1971L4.27588 9.61859L5.27319 9.54538ZM21.2534 4.52269H15.3659V6.52269H21.2534V4.52269ZM23.0034 6.27269C23.0034 5.30619 22.2199 4.52269 21.2534 4.52269V6.52269C21.1154 6.52269 21.0034 6.41076 21.0034 6.27269H23.0034ZM21.2534 8.02269C22.2199 8.02269 23.0034 7.23919 23.0034 6.27269H21.0034C21.0034 6.13462 21.1154 6.02269 21.2534 6.02269V8.02269ZM2.75 8.02269H21.2534V6.02269H2.75V8.02269ZM1 6.27269C1 7.23919 1.7835 8.02269 2.75 8.02269V6.02269C2.88807 6.02269 3 6.13462 3 6.27269H1ZM2.75 4.52269C1.7835 4.52269 1 5.30619 1 6.27269H3C3 6.41076 2.88807 6.52269 2.75 6.52269V4.52269ZM8.63739 4.52269H2.75V6.52269H8.63739V4.52269ZM9.63739 5.52269V3.81817H7.63739V5.52269H9.63739ZM9.63739 3.81817C9.63739 3.94443 9.54004 4 9.47845 4V2C8.48785 2 7.63739 2.78819 7.63739 3.81817H9.63739ZM9.47845 4H14.5248V2H9.47845V4ZM14.5248 4C14.4633 4 14.3659 3.94443 14.3659 3.81817H16.3659C16.3659 2.78819 15.5154 2 14.5248 2V4ZM14.3659 3.81817V5.52269H16.3659V3.81817H14.3659ZM18.9983 19.5528L19.7275 9.61859L17.7329 9.47217L17.0037 19.4064L18.9983 19.5528ZM16.3231 21.9998C17.7064 21.9998 18.8958 20.9547 18.9984 19.5526L17.0037 19.4067C16.9809 19.7176 16.7052 19.9998 16.3231 19.9998V21.9998ZM7.68032 21.9998H16.3231V19.9998H7.68032V21.9998ZM5.00506 19.5526C5.10766 20.9547 6.29708 21.9998 7.68032 21.9998V19.9998C7.29819 19.9998 7.02248 19.7176 6.99973 19.4067L5.00506 19.5526ZM4.27588 9.61859L5.00508 19.5528L6.99971 19.4064L6.27051 9.47217L4.27588 9.61859ZM18.7302 8.54538H5.27319V10.5454H18.7302V8.54538Z",
          fill: "#82869E",
          mask: "url(#icon-u0oj6iqab)"
        }
      }
    ]
  })(props);
};

export { GarbageFilled };
